<template>
    <div class="" v-if="prices">
        <div class="row pb-0">
            <div class="col-md-12 clearfix">
                <h3 class="sectionable">Price</h3>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="author" class="col-form-label">Author</label>
                    <input id="author" class="form-control" type="text" name="author" v-model="prices.author" @input="updateParent">
                </div>
            </div>
            <div class="col-md-6">
                <div class="form-group">
                    <label for="booktype" class="col-form-label">Book Type</label>
                    <input id="booktype" class="form-control" type="text" name="booktype" v-model="prices.booktype" @input="updateParent">
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6">
                <div class="form-group">
                    <label for="price_book_code" class="col-form-label">Price Book Code</label>
                    <input id="price_book_code"  class="form-control" type="text" name="price_book_code" v-model="prices.price_book_code" @input="updateParent">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="base" class="col-form-label">Base</label>
                    <input id="base" class="form-control" type="text" name="base" v-model="prices.base" @input="updateParent">
                </div>
            </div>
            <div class="col-md-3">
                <div class="form-group">
                    <label for="currency" class="col-form-label">Currency</label>
                    <input id="currency" class="form-control" type="text" name="currency" v-model="prices.currency" @input="updateParent">
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Object,
            },
            json: {
                type: String,
            }
        },
        data() {
            return {
                prices: {},
            }
        },
        mounted() {
            this.setPrices();
        },
        watch: {
            value() {
                this.setPrices();
            },
        },
        methods: {
            setPrices() {
                this.prices = {
                    'author': this.value && typeof this.value.author !== 'undefined' ? this.value.author : '',
                    'booktype': this.value && typeof this.value.booktype !== 'undefined' ? this.value.booktype : '',
                    'price_book_code': this.value && typeof this.value.price_book_code !== 'undefined' ? this.value.price_book_code : '',
                    'base': this.value && typeof this.value.base !== 'undefined' ? this.value.base : '',
                    'currency': this.value && typeof this.value.currency !== 'undefined' ? this.value.currency : '',
                }
            },
            updateParent() {
                this.$emit('input', this.prices);
            }
        }
    }
</script>

<style scoped>

</style>
